import { GAD7_FORM_TITLE } from "../constants";

/**
 * test if the form is GAD-7
 * Note: this is a short-term workaround, should improve the criteria in the future
 */
export default function isGAD7Form(title?: string) {
  return title === GAD7_FORM_TITLE;
}
